import React, { useRef, useState } from "react";
import RightVideoPreview from "./RightVideoPreview";
import PreviewChecklist from "./PreviewChecklist";
import "../../styles/videoPreview.css";
import Troubleshoot from "./Troubleshoot";

function PreviewScreen({
  socket,
  ip,
  setDeepgramStatus,
  setLoading,
  setAiTwoWayFlag,
  interviewData,
  setConversationHistory,
  previewConfig,
  currentVideoStream,
  setCurrentVideoStream,
  screenShareStream,
  setScreenShareStream,
  currentAudioStream,
  setCurrentAudioStream,
}) {
  const currentUserVideoRef = useRef(null);
  const [network, setNetwork] = useState();
  const [previewFlag, setPreviewFlag] = useState(false);
  const [callFinalLogApi, setCallFinalLogApi] = useState(false);
  const [concludeDemo, setConcludeDemo] = useState(false);
  const [monitorFlag, setMonitorFlag] = useState(
    !previewConfig?.monitoringToolEnabled ? false : true,
  );

  return (
    <>
      <div className="w-full p-4 xl:py-3 xl:px-2">
        <div className="grid grid-cols-1 xl:grid-cols-[45%_55%] gap-y-8 py-8 lg:py-2 w-[95%] lg:w-[95%] xl:w-[76%] m-auto ">
          <PreviewChecklist
            socket={socket}
            ip={ip}
            network={network}
            setNetwork={setNetwork}
            setDeepgramStatus={setDeepgramStatus}
            callFinalLogApi={callFinalLogApi}
            setAiTwoWayFlag={setAiTwoWayFlag}
            setCallFinalLogApi={setCallFinalLogApi}
            setLoading={setLoading}
            setPreviewFlag={setPreviewFlag}
            interviewData={interviewData}
            setConversationHistory={setConversationHistory}
            previewConfig={previewConfig}
            currentUserVideoRef={currentUserVideoRef}
            currentVideoStream={currentVideoStream}
            setCurrentVideoStream={setCurrentVideoStream}
            screenShareStream={screenShareStream}
            setScreenShareStream={setScreenShareStream}
            currentAudioStream={currentAudioStream}
            setCurrentAudioStream={setCurrentAudioStream}
            setConcludeDemo={setConcludeDemo}
            concludeDemo={concludeDemo}
            previewFlag={previewFlag}
            setMonitorFlag={setMonitorFlag}
            monitorFlag={monitorFlag}
          />
          <RightVideoPreview
            socket={socket}
            network={network}
            setCallFinalLogApi={setCallFinalLogApi}
            previewFlag={previewFlag}
            setLoading={setLoading}
            setAiTwoWayFlag={setAiTwoWayFlag}
            interviewData={interviewData}
            currentUserVideoRef={currentUserVideoRef}
            currentVideoStream={currentVideoStream}
            currentAudioStream={currentAudioStream}
            concludeDemo={concludeDemo}
            monitorFlag={monitorFlag}
            previewConfig={previewConfig}
          />
        </div>
        <Troubleshoot />
      </div>
    </>
  );
}

export default PreviewScreen;
